export default "__VITE_ASSET__Cl22aRLw__"